import { render, staticRenderFns } from "./EditableLayout.vue?vue&type=template&id=5bbafb3e&scoped=true"
import script from "./EditableLayout.vue?vue&type=script&lang=js"
export * from "./EditableLayout.vue?vue&type=script&lang=js"
import style0 from "./EditableLayout.vue?vue&type=style&index=0&id=5bbafb3e&prod&lang=less&scoped=true"
import style1 from "./EditableLayout.vue?vue&type=style&index=1&id=5bbafb3e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbafb3e",
  null
  
)

export default component.exports